/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 26/01/2014
 * Time: 09:10
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('Period', ["Time",
        function (Time) {

        var  Period = function (period)
        {
            this.start = new Time();
            this.end = new Time();
            this.duration = 0;

            if (period != undefined && period)
            {
                this.start.hour = period.start.hour;
                this.start.minute = period.start.minute;
                this.end.hour = period.end.hour;
                this.end.minute = period.end.minute;
                this.updateDuration();
            }
            this.start.updateLabel();
            this.start.updateDateTime();
            this.end.updateLabel();
            this.end.updateDateTime();

        };

        Period.prototype.getObjectResource = function()
        {
            var periodRes = {
                start : this.start.getObjectResource(),
                end : this.end.getObjectResource()
            };
            return periodRes;
        };

        Period.prototype.equals = function (period)
        {
            if (!period)
                return false;
            return  period.start.hour === this.start.hour &&
                period.start.minute === this.start.minute &&
                period.end.hour === this.end.hour &&
                period.end.minute === this.end.minute;
        };

        Period.prototype.adjustEnd = function ()
        {
            var endTime = this.start.getTime() + this.duration;//Get end time
            this.end.hour = Math.floor(endTime/60);//Transform end time to hoor
            this.end.minute = endTime%60;
            this.end.updateLabel();
            this.end.updateDateTime();

        };

        Period.prototype.setDuration = function(duration)
        {
            this.end.setTime(this.start.getTime() + duration);
            this.duration = duration;
            this.end.updateLabel();
            this.end.updateDateTime();
        };

        Period.prototype.moveToStart = function(start)
        {
            if (start && this.start)
            {
                this.start.hour = start.hour;
                this.start.minute = start.minute;
                this.start.updateLabel();
                this.start.updateDateTime();
                this.adjustEnd();
            }
        };

        Period.prototype.setStart = function(start)
        {
            if (start && this.start)
            {
                this.start.hour = start.hour;
                this.start.minute = start.minute;
                this.start.updateLabel();
                this.start.updateDateTime();
                this.updateDuration();
            }
        };

        Period.prototype.setEnd = function(end)
        {
            if (end && this.end)
            {
                this.end.hour = end.hour;
                this.end.minute = end.minute;
                this.end.updateLabel();
                this.end.updateDateTime();
                this.updateDuration();
            }
        };

        Period.prototype.setStartHour = function(hour,updateEnd)
        {
            if (this.start)
            {
                this.start.hour = hour;
                this.start.updateLabel();
                this.start.updateDateTime();
                if (updateEnd)
                    this.adjustEnd();
                else
                    this.updateDuration();
            }
        };

        Period.prototype.setStartMinute = function(minute,updateEnd)
        {
            if (this.start)
            {
                this.start.minute = minute;
                this.start.updateLabel();
                this.start.updateDateTime();
                if (updateEnd)
                    this.adjustEnd();
                else
                    this.updateDuration();
            }
        };

        Period.prototype.setEndHour = function(hour)
        {
            if (this.end)
            {
                this.end.hour = hour;
                this.end.updateLabel();
                this.end.updateDateTime();
                this.updateDuration();
            }
        };

        Period.prototype.setEndMinute = function(minute)
        {
            if (this.end)
            {
                this.end.minute = minute;
                this.end.updateLabel();
                this.end.updateDateTime();
                this.updateDuration();
            }
        };

        Period.prototype.addTime = function(time)
        {
            this.start.setTime(this.start.getTime()+time);
            this.end.setTime(this.end.getTime()+time);
        };

        Period.prototype.removeTime = function(time)
        {
            this.start.setTime(this.start.getTime()-time);
            this.end.setTime(this.end.getTime()-time);
        };

        Period.prototype.updateDuration = function()
        {
            this.duration = this.end.getTime() - this.start.getTime();
        };

        Period.prototype.intersect = function(period)
        {
            if (!period)
                return false;
            return ((period.start.getTime())< (this.end.getTime())) &&
                ((period.end.getTime())> (this.start.getTime()));

        };

        Period.prototype.intersectTime = function(period)
        {
            if (period && period.start.getTime()< this.end.getTime() &&
                period.end.getTime()> this.start.getTime())
                return Math.min(period.end.getTime() - this.start.getTime(),this.end.getTime() - period.start.getTime());
            return 0;

        };

        Period.prototype.contains = function(period)
        {
            return (this.start.getTime()<= period.start.getTime()) &&
                (this.end.getTime()>=period.end.getTime());

        };

        Period.prototype.equals = function(period)
        {
            return period != null && this.start != null && this.end != null && this.start.equals(period.start) && this.end.equals(period.end);
        };

        Period.prototype.compare = function(period1, period2) {
            let comparisonValue;
            if(period1 && period2) {
                comparisonValue = Time.prototype.compare(period1.start, period2.start);
            } else if(period1) {
                comparisonValue = -1;
            } else if(period2) {
                comparisonValue = 1;
            } else {
                comparisonValue = 0;
            }
            return comparisonValue;
        };
        return Period;
    }]);


angular.module('FlexyBeautyApp.services').
    factory('Time',["moment", function (moment){

        var  Time = function ()
        {
            this.hour = 0;
            this.minute = 0;
            this.label = "0h00";

            var momentDate = new moment();
            momentDate.hour(this.hour);
            momentDate.minute(this.minute);
            this.dateTime = momentDate.toDate();
        };
        Time.prototype.getObjectResource = function()
        {
            return {
                hour : this.hour,
                minute : this.minute
            };
        };
        Time.prototype.getTime = function ()
        {
            return this.hour * 60 + this.minute;
        };
        Time.prototype.getTimeInMilli = function ()
        {
            return (this.hour * 60 + this.minute) * 60 * 1000;
        };

        Time.prototype.setTime = function (time)
        {
            this.hour = Math.floor(time/60);//Transform end time to hoor
            this.minute = time%60;

            this.updateDateTime();
            this.updateLabel();
        };
        Time.prototype.setTimeByHm = function (h,m)
        {
            this.hour = h;
            this.minute = m;
            this.updateLabel();
            this.updateDateTime();
        };
        Time.prototype.equals = function (time)
        {
            if (!time)
                return false;
            return  time.hour === this.hour && time.minute === this.minute;

        };
        Time.prototype.updateLabel = function()
        {
            this.label = this.getLabel();
        };
        Time.prototype.updateDateTime = function()
        {
            let momentDate = new moment();
            momentDate.hour(this.hour);
            momentDate.minute(this.minute);

            this.dateTime = momentDate.toDate();
        };
        Time.prototype.getLabel = function()
        {
            var timeMoment = new moment().hour(this.hour).minute(this.minute);
            return timeMoment.format("LT");
        };

        Time.prototype.updateHourMinuteFromDate = function(){
            if(this.dateTime && this.dateTime.getHours() != null && this.dateTime.getMinutes() != null) {
                this.hour = new moment(this.dateTime).hour();
                this.minute = new moment(this.dateTime).minute();
            }
        };

        Time.prototype.equals = function(time)
        {
           return time != null && this.hour === time.hour && this.minute === time.minute;
        };

        Time.prototype.compare = function(time1, time2) {
            let comparisonValue;
            let isValidForComparison = function (time) {
                return time && !isNaN(time.getTimeInMilli());
            };

            if(isValidForComparison(time1) && isValidForComparison(time2)) {
                comparisonValue = time1.getTimeInMilli() - time2.getTimeInMilli();
            } else if(isValidForComparison(time1) && !isValidForComparison(time2)) {
                comparisonValue = -1;
            } else if(!isValidForComparison(time1) && isValidForComparison(time2)) {
                comparisonValue = 1;
            } else {
                comparisonValue = 0;
            }

            return comparisonValue;
        };

        return Time;
    }]);


// WEBPACK FOOTER //
// ./js/services/modelsViews/Period.js